import React from 'react';
import './ProductTitle.css';

function ProductTitle({product}) {
    if (!product) return '';

    return (
        <div className='product-title'>
            <div className='product-title_top-row'>
                <div className='product-title_brand'>{product.brand || 'Sin marca'}</div>
                {product.sku && <div className='product-title_id'>{product.sku}</div>}
            </div>
            <div className='product-title_bottom-row'>
                <div className='product-title_name'>{product.name || 'Sin nombre'}</div>
            </div>
        </div>
    );
}

export default ProductTitle;